export const API_SUCCESS_CODES = [201, 200];
export const API_FAILURE_CODES = [400, 403];
